import React from 'react'
import { Field } from 'formik'

import {
  renderTextInput,
  renderTextInput2,
  ZipInput,
} from 'components/forms'
import { StateAutocomplete } from 'components/forms/StateAutocomplete'
import { renderSelectInput } from 'steps/lead-gen/LeadGenHelpers'

import {
  ADDRESS_NOT_VALID,
  ACCEPT,
  OK,
  CHANGE_ADDRESS,
  CLOSE,
  SUGGESTIONS,
} from './constants'

const capitalize = str => {
  return str.toLowerCase().charAt(0).toUpperCase() + str.slice(1)
}

const AddressModal = ({
  notValid = false,
  values,
  suggestedAddress,
  onClose,
  onAccept,
  onSubmit,
}) => {
  const addressMap = Object.entries(suggestedAddress)

  const handleOnAccept = () => {
    onSubmit && onSubmit(values)
    onAccept && onAccept(suggestedAddress)
  }

  if (notValid) {
    return (
      <div className="suggestion_address_modal">
        <div className="address_suggestion">
          <h2>{ADDRESS_NOT_VALID}</h2>
          <span>{CHANGE_ADDRESS}</span>
        </div>
        <div className="invalid_address_buttons">
          <button type="submit" onClick={onClose} aria-label="Close">
            {OK}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="suggestion_address_modal">
      <div className="address_suggestion">
        <h2>{SUGGESTIONS}</h2>
        {addressMap.map(([address, value]) => {
          return (
            value && (
              <div>
                <span className="title">{capitalize(address)}: </span>
                <span>{capitalize(value || '')}</span>
              </div>
            )
          )
        })}
      </div>
      <div className="action_buttons">
        <button onClick={onClose} aria-label="Close">
          {CLOSE}
        </button>
        <button type={'submit'} onClick={handleOnAccept}>
          {ACCEPT}
        </button>
      </div>
    </div>
  )
}

const NameFields = ({ errors, touched }) => {
  return (
    <>
      <li className="form__element half-size" key={`firstName`}>
        <Field
          name="firstName"
          type="text"
          label={`First Name*`}
          component={renderTextInput2}
          variant="filled"
          touched={touched.firstName && true ? 'true' : ''}
        />
        {errors.firstName && <p className="error">{errors.firstName}</p>}
      </li>
      <li className="form__element half-size" key={`lastName`}>
        <Field
          name="lastName"
          type="text"
          label="Last Name*"
          placeholder={'Last Name'}
          component={renderTextInput}
          variant="filled"
          touched={touched.lastName && true ? 'true' : ''}
        />
        {errors.lastName && <p className="error">{errors.lastName}</p>}
      </li>
    </>
  )
}

const AddressFields = ({ values, lookupAddress, errors }) => {
  return (
    <>
      <li className="form__element" key={`address`}>
        <Field
          name={'address1'}
          type="text"
          label={`Address Line 1*`}
          variant="filled"
          component={renderTextInput}
        />
        {errors.address1 && <p className="error">{errors.address1}</p>}
      </li>
      <li className="form__element" key={`address2`}>
        <Field
          name={'address2'}
          type="text"
          label={`Address Line 2`}
          variant="filled"
          component={renderTextInput}
        />
        {errors.address2 && <p className="error">{errors.address2}</p>}
      </li>
      <li className="form__element third-size" key={`city`}>
        <Field
          name={'city'}
          type="text"
          label={`City*`}
          variant="filled"
          component={renderTextInput}
        />
        {errors.city && <p className="error">{errors.city}</p>}
      </li>
      <li className="form__element third-size" key={`state`}>
        <Field
          name={'state'}
          type="text"
          label={`State*`}
          variant="filled"
          component={StateAutocomplete}
        />
        {errors.state && <p className="error">{errors.state}</p>}
      </li>
      <li className="form__element third-size" key={`zip`}>
        <Field
          name={'postalCode'}
          type="text"
          label={`Postal Code*`}
          values={values}
          lookupAddress={lookupAddress}
          component={ZipInput}
        />

        {errors.postalCode && <p className="error">{errors.postalCode}</p>}
      </li>
    </>
  )
}
export { AddressFields, NameFields, AddressModal }
